import { usePathname } from 'next/navigation'
import { useMemo } from 'react'

import { TMarket } from '../../types/common/common.types'
import { BUYFLOW_PATHS, IBuyflowPathKey } from '../../utils/constants/common'

export const useIsPage = (pages: IBuyflowPathKey[], market: TMarket) => {
  const pathname = usePathname()

  return useMemo(() => {
    return (
      pages.some((page) => pathname.includes(BUYFLOW_PATHS[market][page])) ||
      false
    )
  }, [market, pathname])
}
